import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

/**
 * Backs the merchant file exchange SFTP identity provider: the SFTP username
 * is the team id. Password requests verify a public API bearer token; key
 * requests retrieve the team's registered SSH public key for Transfer Family
 * to verify.
 */
export const verifyFileExchangeAccess = {
  name: "verifyFileExchangeAccess" as const,
  input: z.object({
    teamId: zExt.objectId(),
    bearerToken: z.string().optional(),
  }),
  output: z.object({
    authorized: z.boolean(),
    sshPublicKeys: z.array(z.string()),
  }),
};
